import { getOriginalPosition, nearestValue, checkElementsInCollision } from '../engine/positions'

export const initialState = {
  id: null,
  elements: [],
  selectedElement: null,
  title: '',
  originalPosition: {
    x: null, y: null, divWidth: null, divHeight: null,
  },
  reloadVersion: 0,
  res: 6,
  baseRes: 3.5,
  vRes: 2,
  woodColor: 'black',
  metalColor: 'black',
  showTuto: false,
}


export const reducer = (state, action) => {
  const factor = state.res / state.baseRes

  const maxId = state.elements
    .reduce((cur, res) => (res.id > cur.id ? res : cur), { id: -1 })

  const curId = maxId.id + 1

  switch (action.type) {
    case 'addElement': {
      const {
        originalPositionX,
        originalPositionY,
      } = getOriginalPosition(state, action.elementType)
      const newState = {
        ...state,
        elements: [
          ...state.elements,
          {
            id: curId,
            type: action.elementType,
            x: originalPositionX,
            y: originalPositionY,
          },
        ],
        selectedElement: curId,
      }
      return { ...newState, elements: checkElementsInCollision(newState.elements) }
    }
    case 'addBox':
      return {
        ...state,
        elements: [
          ...state.elements,
          {
            id: curId,
            type: 'box',
            x: 80,
            y: 44,
            width: (action.dimension && action.dimension.boxType === 'vArrow' ? 16 : action.dimension.width) * 4,
            height: (action.dimension && action.dimension.boxType === 'hArrow' ? 16 : action.dimension.height) * 4,
            realWidth: parseInt(action.dimension.width, 10),
            realHeight: parseInt(action.dimension.height, 10),
            boxName: action.dimension.boxName || null,
            boxType: action.dimension.boxType || null,
            view: true,
            viewQuotes: true,
          },
        ],
        selectedElement: curId,
      }

    case 'setItemPosition': {
      const newElements = state.elements.map((el) => {
        if (el.id === action.id) {
          return {
            ...el,
            x: nearestValue(Math.round((action.itemPosition.lastX - state.originalPosition.x) * factor), el.type.slice(0, 4) === 'grid' ? 20 : 4),
            y: nearestValue(Math.round((action.itemPosition.lastY - state.originalPosition.y) * factor), el.type.slice(0, 4) === 'box' ? 4 : 44),
          }
        }
        return el
      })

      return {
        ...state,
        elements: checkElementsInCollision(newElements),
      }
    }

    case 'incPosition': {
      if (state.selectedElement === null) {
        return { ...state }
      }
      const incCurrentElement = state.elements.filter((el) => el.id === state.selectedElement)[0]
      const incDeltaStepX = incCurrentElement.type.slice(0, 4) === 'grid' ? 20 : 4
      const incDeltaStepY = incCurrentElement.type.slice(0, 4) === 'box' ? 4 : 44
      const incDeltaX = action.direction === 'left' ? -1 * incDeltaStepX
        : action.direction === 'right' ? 1 * incDeltaStepX
          : 0
      const incDeltaY = action.direction === 'up' ? -1 * incDeltaStepY
        : action.direction === 'down' ? 1 * incDeltaStepY
          : 0

      const incCurX = incCurrentElement.x + incDeltaX
      const incCurY = incCurrentElement.y + incDeltaY

      const newIncPositionElements = state.elements.map((el) => (el.id === state.selectedElement
        ? {
          ...el,
          x: nearestValue(incCurX, el.type.slice(0, 4) === 'grid' ? 20 : 4, 0, (state.originalPosition.divWidth * factor - incCurrentElement.width)),
          y: nearestValue(incCurY, el.type.slice(0, 4) === 'box' ? 4 : 44, 0, state.originalPosition.divHeight * factor - incCurrentElement.height),
        } : el))

      return {
        ...state,
        elements: checkElementsInCollision(newIncPositionElements),
      }
    }

    case 'selectElement':
      return {
        ...state,
        selectedElement: action.id,
      }

    case 'removeSelectedElement':
      return {
        ...state,
        elements: checkElementsInCollision(state.elements.filter(
          (el) => el.id !== state.selectedElement,
        )),
        selectedElement: null,
      }

    case 'removeElement':
      return {
        ...state,
        elements: checkElementsInCollision(state.elements.filter((el) => el.id !== action.id)),
        selectedElement: null,
      }

    case 'setOriginalPosition':
      return {
        ...state,
        originalPosition: action.position,
      }

    case 'reset': {
      return {
        ...initialState,
        baseRes: action.baseRes || initialState.baseRes,
        showTuto: action.showTuto,
      }
    }

    case 'loadElements': {
      const showTuto = action.localState
        ? (state.showTuto || (action.localState.elements.length === 0))
        : true

      return action.localState
        ? {
          ...state,
          id: action.localState.id,
          elements: action.localState.elements,
          title: action.localState.title,
          res: action.localState.res,
          vRes: action.localState.vRes,
          metalColor: action.localState.metalColor || 'black',
          woodColor: action.localState.woodColor || 'black',
          showTuto,
        }
        : { ...state, showTuto: true }
    }

    case 'setTitle':
      return {
        ...state,
        title: action.title,
      }

    case 'setWoodColor':
      return {
        ...state,
        woodColor: action.woodColor,
      }


    case 'setMetalColor':
      return {
        ...state,
        metalColor: action.metalColor,
      }

    case 'setRes':
      return {
        ...state,
        res: action.res,
      }

    case 'setBaseRes':
      return {
        ...state,
        baseRes: action.baseRes,
      }
    case 'setVRes':
      return {
        ...state,
        vRes: action.vRes,
      }

    case 'setBoxVisibility':
      return {
        ...state,
        elements: state.elements.map(
          (el) => (el.id === action.id ? { ...el, view: action.view } : el),
        ),
      }

    case 'setBoxQuotesVisibility':
      return {
        ...state,
        elements: state.elements.map(
          (el) => (el.id === action.id ? { ...el, viewQuotes: action.viewQuotes } : el),
        ),
      }
    case 'setShowTuto': {
      return {
        ...state,
        showTuto: action.showTuto,
      }
    }

    default:
      return state
  }
}
